import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowBottomLeftCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9 13.5859V11H7V17H13V15H10.4141L14.4141 11L13 9.58594L9 13.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomLeftCorner;
